// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1bh2q","question":"Question_question__32PLW","description":"Question_description__3rs8A"};